/*************************
 * @license
 * Copyright 2024 Myenergi Ltd. All rights reserved.
 * No part of this work may be reproduced, stored in a retrieval system of any nature, or transmitted, in any form or by any means without the prior written permission of Myenergi Ltd., the copyright owner.
 * If any unauthorised acts are carried out in relation to this copyright work, a civil claim for damages may be made and/or a criminal prosecution may result.
 *************************/

import { datadogRum } from "@datadog/browser-rum";

datadogRum.init({
  applicationId: "4751d4f5-916e-4294-8575-eaf89bb3ec1f",
  clientToken: "pub0ef87513411c380a7480190a0f5a5cd1",
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: "datadoghq.eu",
  service: "admin-portal",
  env: process.env.ENV_NAME === "prod" ? "prod_dataserver" : "test_dataserver",
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: process.env.ENV_NAME === "prod" ? 20 : 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "mask-user-input",
});
